/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	BillingStateResponse,
	CreateBillingCheckoutRequest,
	CreateBillingCheckoutResponse,
	PackageListResponse,
	PraetoidError,
	PurchaseCreditsRequest,
	PurchaseCreditsResponse,
	UpdateSettingsRequest
} from '../models';

/**
 * @summary Create a billing checkout session
 */
export const createBillingCheckout = (
	createBillingCheckoutRequest: CreateBillingCheckoutRequest
) => {
	return customInstance<CreateBillingCheckoutResponse>({
		url: `/billing/checkout`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: createBillingCheckoutRequest
	});
};

export const getCreateBillingCheckoutMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createBillingCheckout>>,
		TError,
		{ data: CreateBillingCheckoutRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createBillingCheckout>>,
	TError,
	{ data: CreateBillingCheckoutRequest },
	TContext
> => {
	const mutationKey = ['createBillingCheckout'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createBillingCheckout>>,
		{ data: CreateBillingCheckoutRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createBillingCheckout(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateBillingCheckoutMutationResult = NonNullable<
	Awaited<ReturnType<typeof createBillingCheckout>>
>;
export type CreateBillingCheckoutMutationBody = CreateBillingCheckoutRequest;
export type CreateBillingCheckoutMutationError = ErrorType<PraetoidError>;

/**
 * @summary Create a billing checkout session
 */
export const useCreateBillingCheckout = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createBillingCheckout>>,
			TError,
			{ data: CreateBillingCheckoutRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof createBillingCheckout>>,
	TError,
	{ data: CreateBillingCheckoutRequest },
	TContext
> => {
	return useMutation(getCreateBillingCheckoutMutationOptions(options), queryClient);
};
/**
 * @summary Purchase prepaid credits
 */
export const purchaseCredits = (purchaseCreditsRequest: PurchaseCreditsRequest) => {
	return customInstance<PurchaseCreditsResponse>({
		url: `/billing/credits/purchase`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: purchaseCreditsRequest
	});
};

export const getPurchaseCreditsMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof purchaseCredits>>,
		TError,
		{ data: PurchaseCreditsRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof purchaseCredits>>,
	TError,
	{ data: PurchaseCreditsRequest },
	TContext
> => {
	const mutationKey = ['purchaseCredits'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof purchaseCredits>>,
		{ data: PurchaseCreditsRequest }
	> = (props) => {
		const { data } = props ?? {};

		return purchaseCredits(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type PurchaseCreditsMutationResult = NonNullable<
	Awaited<ReturnType<typeof purchaseCredits>>
>;
export type PurchaseCreditsMutationBody = PurchaseCreditsRequest;
export type PurchaseCreditsMutationError = ErrorType<PraetoidError>;

/**
 * @summary Purchase prepaid credits
 */
export const usePurchaseCredits = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof purchaseCredits>>,
			TError,
			{ data: PurchaseCreditsRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof purchaseCredits>>,
	TError,
	{ data: PurchaseCreditsRequest },
	TContext
> => {
	return useMutation(getPurchaseCreditsMutationOptions(options), queryClient);
};
/**
 * @summary List sellable billing packages
 */
export const listPackages = () => {
	return customInstance<PackageListResponse>({ url: `/billing/packages`, method: 'GET' });
};

export const getListPackagesQueryKey = () => {
	return ['billing', 'packages'] as const;
};

export const getListPackagesQueryOptions = <
	TData = Awaited<ReturnType<typeof listPackages>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPackages>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListPackagesQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listPackages>>> = () => listPackages();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listPackages>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPackagesQueryResult = NonNullable<Awaited<ReturnType<typeof listPackages>>>;
export type ListPackagesQueryError = ErrorType<PraetoidError>;

export function useListPackages<
	TData = Awaited<ReturnType<typeof listPackages>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPackages>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPackages>>,
					TError,
					Awaited<ReturnType<typeof listPackages>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPackages<
	TData = Awaited<ReturnType<typeof listPackages>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPackages>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPackages>>,
					TError,
					Awaited<ReturnType<typeof listPackages>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPackages<
	TData = Awaited<ReturnType<typeof listPackages>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPackages>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List sellable billing packages
 */

export function useListPackages<
	TData = Awaited<ReturnType<typeof listPackages>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPackages>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListPackagesQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update billing settings
 */
export const updateBillingSettings = (updateSettingsRequest: UpdateSettingsRequest) => {
	return customInstance<BillingStateResponse>({
		url: `/billing/settings`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: updateSettingsRequest
	});
};

export const getUpdateBillingSettingsMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateBillingSettings>>,
		TError,
		{ data: UpdateSettingsRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateBillingSettings>>,
	TError,
	{ data: UpdateSettingsRequest },
	TContext
> => {
	const mutationKey = ['updateBillingSettings'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateBillingSettings>>,
		{ data: UpdateSettingsRequest }
	> = (props) => {
		const { data } = props ?? {};

		return updateBillingSettings(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateBillingSettingsMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateBillingSettings>>
>;
export type UpdateBillingSettingsMutationBody = UpdateSettingsRequest;
export type UpdateBillingSettingsMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update billing settings
 */
export const useUpdateBillingSettings = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateBillingSettings>>,
			TError,
			{ data: UpdateSettingsRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updateBillingSettings>>,
	TError,
	{ data: UpdateSettingsRequest },
	TContext
> => {
	return useMutation(getUpdateBillingSettingsMutationOptions(options), queryClient);
};
/**
 * @summary Get current billing state
 */
export const getBillingState = () => {
	return customInstance<BillingStateResponse>({ url: `/billing/state`, method: 'GET' });
};

export const getGetBillingStateQueryKey = () => {
	return ['billing', 'state'] as const;
};

export const getGetBillingStateQueryOptions = <
	TData = Awaited<ReturnType<typeof getBillingState>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingState>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetBillingStateQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingState>>> = () =>
		getBillingState();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getBillingState>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBillingStateQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingState>>>;
export type GetBillingStateQueryError = ErrorType<PraetoidError>;

export function useGetBillingState<
	TData = Awaited<ReturnType<typeof getBillingState>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingState>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getBillingState>>,
					TError,
					Awaited<ReturnType<typeof getBillingState>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetBillingState<
	TData = Awaited<ReturnType<typeof getBillingState>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingState>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getBillingState>>,
					TError,
					Awaited<ReturnType<typeof getBillingState>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetBillingState<
	TData = Awaited<ReturnType<typeof getBillingState>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingState>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get current billing state
 */

export function useGetBillingState<
	TData = Awaited<ReturnType<typeof getBillingState>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingState>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetBillingStateQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
